export default ({ $auth, redirect }) => {
  const isLoggedIn = $auth.$state.user && $auth.$state.user.id
  if (isLoggedIn) return redirect('/dashboard')
}
